import React, { ReactElement, useContext } from "react"
import Select from "react-select"

import { FormLabel, Loading } from "@wfp/ui"

import { MappingPriceContext } from "../../../../providers/MappingPricesContext"

import MappingStepHeader from "./MappingStepHeader"

const MappingHeader = (): ReactElement => {
  const { schema, onGlobalEdit, loadingMapping } = useContext(MappingPriceContext)

  const headerRows = Array.from({ length: 5 }, (_, i) => ({ value: `${i + 1}`, label: `${i + 1}` }))

  if (loadingMapping)
    return (
      <div className="min-h-[430px] w-full flex justify-center items-center">
        <Loading small withOverlay={false} />
      </div>
    )

  return (
    <div>
      <MappingStepHeader
        title="Header"
        descriptions={[
          "Let's map the fields in the Excel file you have uploaded.",
          "First of all please tell me at which row I can read the header.",
        ]}
      />

      <div className="mt-4 w-full xl:w-1/2">
        <FormLabel htmlFor="header-row">Header Row</FormLabel>
        <p className="text-sm mb-1">Select the row number that contains the header of the Excel file.</p>
        <Select
          className="max-w-[250px]"
          inputId="header-row"
          placeholder="Select header row"
          options={headerRows}
          value={schema.rowHeader ? { value: `${schema.rowHeader}`, label: `${schema.rowHeader}` } : null}
          onChange={e => onGlobalEdit("rowHeader", e?.value ?? "")}
          menuPosition="fixed"
          classNamePrefix="select"
          menuPlacement="auto"
        />
      </div>
    </div>
  )
}

export default MappingHeader
